__turbopack_context__.v({
  "data": "OrganizerStats-module-scss-module__9NP0EW__data",
  "label": "OrganizerStats-module-scss-module__9NP0EW__label",
  "stat": "OrganizerStats-module-scss-module__9NP0EW__stat",
  "statWithDivider": "OrganizerStats-module-scss-module__9NP0EW__statWithDivider",
  "wrapper": "OrganizerStats-module-scss-module__9NP0EW__wrapper",
});
